import { useTranslation } from "react-i18next";
import type { i18n as I18n, TFunction } from "i18next";

/** The dock's strings: their own namespace, next to the viewer's, so neither bundle grows into the other. */
export const dockMessages = {
  en: {
    open: "Ask the assistant",
    openHint: "Press / to type",
    title: "Assistant",
    collapse: "Collapse the assistant",
    placeholder: "Say what to change, e.g. make this wall red",
    hint: "Select a wall in the world, then tell the assistant what to do with it.",
    send: "Send",
    log: "Assistant conversation",
    pickerLabel: "Quick material",
    pickerNone: "Select a building or a wall to restyle it.",
    applied: "{{material}} applied",
    undo: "Undo",
    undoDone: "Reverted",
    failed: "That change did not work.",
    modelUsed: "Model: {{model}}",
    modelUsedEffort: "Model: {{model}} · Effort: {{effort}}",
    material: {
      plaster: "Plaster",
      brick: "Brick",
      glass: "Glass",
      wood: "Wood",
      concrete: "Concrete",
      red: "Red paint",
      blue: "Blue paint",
      green: "Green paint",
    },
  },
  tr: {
    open: "Asistana sor",
    openHint: "Yazmak için / tuşu",
    title: "Asistan",
    collapse: "Asistanı küçült",
    placeholder: "Neyi değiştireceğini söyle, örn. bu duvarı kırmızı yap",
    hint: "Dünyada bir duvar seç, sonra asistana onunla ne yapacağını söyle.",
    send: "Gönder",
    log: "Asistan konuşması",
    pickerLabel: "Hızlı malzeme",
    pickerNone: "Boyamak için bir bina veya duvar seç.",
    applied: "{{material}} uygulandı",
    undo: "Geri al",
    undoDone: "Geri alındı",
    failed: "Bu değişiklik yapılamadı.",
    modelUsed: "Model: {{model}}",
    modelUsedEffort: "Model: {{model}} · Çaba: {{effort}}",
    material: {
      plaster: "Sıva",
      brick: "Tuğla",
      glass: "Cam",
      wood: "Ahşap",
      concrete: "Beton",
      red: "Kırmızı boya",
      blue: "Mavi boya",
      green: "Yeşil boya",
    },
  },
} as const;

export const DOCK_NS = "worldDock";

function ensureDockBundles(i18n: I18n): void {
  for (const [lng, bundle] of Object.entries(dockMessages)) {
    if (!i18n.hasResourceBundle(lng, DOCK_NS)) {
      i18n.addResourceBundle(lng, DOCK_NS, bundle, true, false);
    }
  }
}

export function useDockT(): TFunction<typeof DOCK_NS> {
  const { i18n } = useTranslation();
  ensureDockBundles(i18n);
  return useTranslation(DOCK_NS).t;
}
